// @flow

const parseCookieString = (str) => {
  return str
    .split(";")
    .filter((v) => v.length > 0)
    .map((v) => v.split("="))
    .reduce((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});
};

export default parseCookieString;
